// extracted by mini-css-extract-plugin
export default {"wrapper":"empty-homework_wrapper__vO+Ah","img":"empty-homework_img__dy4x4","description":"empty-homework_description__-ensp","button":"empty-homework_button__ZOInK"};